import { render, staticRenderFns } from "./kalite.vue?vue&type=template&id=0baf0f33&scoped=true&"
import script from "./kalite.vue?vue&type=script&lang=js&"
export * from "./kalite.vue?vue&type=script&lang=js&"
import style0 from "./kalite.vue?vue&type=style&index=0&id=0baf0f33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf0f33",
  null
  
)

export default component.exports